<template>
  <span></span>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';

const MARKER_OPTIONS = {
  default: {
    width: 25,
    height: 40,
    pixelOffset: [0, -20],
    image: require('@/asset/windfarm/marker-icon.png')
  },
  tower: {
    scale: 7.5,
    uri: `${process.env.VUE_APP_URL}/3d/data/windTower.glb`
  },
  turbine: {
    scale: 1.3,
    uri: `${process.env.VUE_APP_URL}/3d/data/fengji.glb`
  }
};

export default {
  name: 'Sm3dGraphics',
  props: {
    /**
     * marker
     * [{
     * coordinates: [116.400772400405, 40.022863398376, 12.9858561288565]
     * type: 'tower', // default | tower | turbine
     * id: 'tower_1',
     * }]
     * polygon 支持两种格式的数据
     * 1. [[116.400772400405, 40.022863398376, 12.9858561288565]]
     * 2.
     * [{
     * coordinates: [[116.400772400405, 40.022863398376, 12.9858561288565]]
     * type: 'windfarm', // windfarm | exclusive
     * image: 'url'
     * id: 'windfarm_1'
     * }]
     * polyline 支持两种格式的数据
     * 1. [[116.400772400405, 40.022863398376, 12.9858561288565]]
     * 2.
     * [{
     * coordinates: [[116.400772400405, 40.022863398376, 12.9858561288565]]
     * type: 'default', //
     * id: 'windfarm_1'
     * }]
     */
    data: Object,
    zoomToFirst: Boolean,
  },
  data() {
    return {
      sharedState: window.store.state,
      playing: false
    };
  },

  // 监听viewer
  computed: {
    isInitViewer: function() {
      return this.sharedState.isInitViewer;
    }
  },
  methods: {
    init() {
      this.entities = {};
      this.syncData();
    },

    syncData() {
      this.clear();
      console.log('sync data', this.data);
      if (isEmpty(this.data)) return;
      const { Cesium, viewer } = window;
      const colorMap = {
        windfarm: Cesium.Color.ORANGE.withAlpha(0.0),
        exclusive: Cesium.Color.BLUE.withAlpha(0.0)
      };

      let centerEntity = null;

      const { polygons, markers, polylines } = this.data;

      //自定义polygon
      (polygons || []).forEach((item, i) => {
        let { coordinates, type } = item;
        if (isArray(item)) {
          coordinates = item;
          type = 'windfarm';
        }
        const entityOpts = {
          id: item.id || `${type}_${i}`,
          polygon: {
            hierarchy: new Cesium.PolygonHierarchy(
              coordinates.map(point => Cesium.Cartesian3.fromDegrees(...point))
            ),
            material: colorMap[type]
          }
        };
        if (item.image) {
          // clampToGround: true,
          entityOpts.polygon.material = new Cesium.ImageMaterialProperty({
            image: item.image,
            repeat: new Cesium.Cartesian2(1, 1),
            transparent: true,
          });
        }
        const entity = viewer.entities.add(entityOpts);
        this.entities[entityOpts.id] = entity;
        if (i === 0 && !centerEntity && type === 'windfarm') {
          centerEntity = entity;
        }
      });
      // 自定义polyline
      (polylines || []).forEach((item, i) => {
        let { coordinates, type } = item;
        if (isArray(item)) {
          coordinates = item;
          type = 'default';
        }
        const entityOpts = {
          id: item.id || `polyline_${type}_${i}`,
          polyline: {
            positions: coordinates.map(point =>
              Cesium.Cartesian3.fromDegrees(...point)
            ),
            width: 4,
            material: Cesium.Color.WHITE,
            clampToGround: true
          }
        };
        const entity = viewer.entities.add(entityOpts);
        this.entities[entityOpts.id] = entity;
        if (i === 0 && !centerEntity) {
          centerEntity = entity;
        }
      });

      if (!isEmpty(markers)) {
        for (var i = 0; i < markers.length; i++) {
          var marker = markers[i];
          let { coordinates, type } = marker;
          if (isArray(marker)) {
            coordinates = marker;
            type = 'default';
          }
          const opts = MARKER_OPTIONS[type];
          if (!opts) return;
          const entityOpts = {
            id: marker.id || `${type}_${i}`,
            position: Cesium.Cartesian3.fromDegrees(
              coordinates[0],
              coordinates[1],
              coordinates[2] || 0
            )
          };

          if (type === 'default') {
            entityOpts.billboard = {
              ...opts,
              pixelOffset: new Cesium.Cartesian2(...opts.pixelOffset),
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
            };
          } else {
            entityOpts.model = {
              ...opts,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
            };
          }
          const entity = viewer.entities.add(entityOpts);
          this.entities[entityOpts.id] = entity;
          if (i === 0 && !centerEntity) {
            centerEntity = entity;
          }
        }
      }
      // console.log('entity', this.entities);

      if (centerEntity && this.zoomToFirst) {
        viewer.zoomTo(centerEntity);
        console.log('zoomTo', centerEntity);
      }

      // circle
      // http://cesium.xin/cesium/cn/Documentation1.62/CircleGeometry.html?classFilter=circle
    },
    clear() {
      const { viewer } = window;
      if (this.entities) {
        viewer.entities.removeAll();
        // Object.keys(this.entities).forEach(key => {
        //   viewer.entities.removeById(key);
        // });
      }
      this.entities = {};
    }
  },
  watch: {
    data() {
      this.syncData();
    },
    isInitViewer() {
      this.init();
    }
  },
  mounted() {
    if (this.isInitViewer) {
      this.init();
    }
  }
};
</script>
<style lang="less" scoped></style>
